<div class="col-lg-9 col-md-12 col-sm-12">
  <div class="info-title">{{ 'createPoint.title.infos' | translate }}</div>
  <section id="fullForm" class="mt-4" [formGroup]="infosForm">
    <div class="row">
      <div class="col-lg-8 col-md-12 col-sm-12">
        <span class="info-content">{{ 'global.title' | translate }} *</span>
        <textarea pInputTextarea formControlName="objetSynthese" rows="1" style="width: 100%;"
          autoResize="true"></textarea>
      </div>
      <div class="col-lg-4 col-md-12 col-sm-12">
        <span class="info-content">{{ 'status' | translate }} *</span>
        <p-dropdown *ngIf="groupeSecuriteRightsPoints?.changerStatut" [itemSize]="30" formControlName="statutId"
          [options]="listOfStatuts" styleClass="w-100" [placeholder]="'selectAStatus' | translate" appendTo="body"
          [showClear]="true" [filter]="true">
        </p-dropdown>
      </div>

      <div class="col-lg-6 col-md-12 col-sm-12 mt-4">
        <span class="info-content">{{ 'meetingTypeLinked' | translate }} *</span>
        <p-dropdown [itemSize]="30" formControlName="typeSeanceId" (onChange)="selectedMeetingPoint($event, false)"
          [options]="listOfTypesSeances | sort: 'label' : 'ASC'" styleClass="w-100"
          [placeholder]="listOfTypesSeances.length > 0  ? ('selectAMeetingType' | translate) : ('noMeetingTypeAvailable' | translate)"
          appendTo="body" [showClear]="true" [filter]="true" [autoDisplayFirst]="false"
          [disabled]="avoidChangeSeance || (listOfTypesSeances.length === 0)" (onClear)="clearTypeSeance()">
        </p-dropdown>
      </div>
      <div class="col-lg-6 col-md-12 col-sm-12 mt-4">
        <span class="info-content">{{ 'meetingDate' | translate }} *
          <i class="bi bi-info-circle"
            [pTooltip]="'pleaseChooseATypeSeanceLinkedToBeAbleToSelectASeance' | translate"></i></span>
        <p-dropdown [itemSize]="30" optionLabel="label" optionValue="value" formControlName="seanceId"
          [options]="seances | sort: 'date' : 'ASC'" styleClass="w-100" appendTo="body" [filter]="true" [ngClass]="{
            seanceSelectedGreen: seanceSelectedInfos?.verrouille === false,
            seanceSelectedOrange: seanceSelectedInfos?.verrouille === true
          }" (onChange)="displaySeanceSelected()" [autoDisplayFirst]="false">
        </p-dropdown>

      </div>
      <div class="col-lg-8 col-md-12 col-sm-12 mt-4 p-fluid">
        <label class="info-content">{{ 'department' | translate }} *</label>
        <p-treeSelect class="w-100" styleClass="w-100" [formControl]="service" [loading]="fetchingServices()"
          [options]="servicesOptions()" #serviceTreeSelect selectionMode="single" [filter]="true" [filterBy]="'label'"
          appendTo="body" (onNodeSelect)="onServiceSelect($event)">
        </p-treeSelect>
      </div>
      <div class="col-lg-4 col-md-12 col-sm-12 mt-4">
        <span class="info-content">Passage service</span>
        <input type="number" pInputText formControlName="triService" class="w-100" />
      </div>
      <div class="col-lg-4 col-md-12 col-sm-12 mt-4">
        <span class="info-content">{{ 'matter' | translate }} <span
            *ngIf="mandatoryPointParameters?.matiereObligatoire"> *</span></span>
        <p-dropdown *ngIf="groupeSecuriteRightsPoints?.changerMatiere" [itemSize]="30" formControlName="matiereId"
          [options]="listOfMatieres" styleClass="w-100" [placeholder]="'selectAMatter' | translate" appendTo="body"
          [showClear]="true" [filter]="true" (onChange)="onMatterChange($event)">
        </p-dropdown>
      </div>
      <div class="col-lg-4 col-md-12 col-sm-12 mt-4">
        <span class="info-content">{{ 'echevinat' | translate }} <span
            *ngIf="mandatoryPointParameters?.echevinatObligatoire"> *</span>
        </span>
        <p-dropdown [itemSize]="30" formControlName="echevinatId" optionLabel="label" optionValue="value"
          [options]="listOfEchevinatsRights" styleClass="w-100"
          *ngIf="groupeSecuriteRightsPoints?.changerEchevinat && listOfEchevinats" [placeholder]="
            !infosForm.value.matiereId && !groupeSecuriteRightsPoints?.changerEchevinat
              ? ('noEchevinatSelectable' | translate)
              : ('selectAnEchevinat' | translate)
          " appendTo="body" [showClear]="true" [filter]="true">
        </p-dropdown>


      </div>
      <div class="col-lg-4 col-md-12 col-sm-12 mt-4">
        <span class="info-content">{{ 'pointType' | translate }} *</span>
        <p-dropdown [itemSize]="30" formControlName="typeId" [options]="listOfTypePoint" styleClass="w-100"
          [placeholder]="'selectAPointType' | translate" appendTo="body" [showClear]="true" [autoDisplayFirst]="false"
          [disabled]="!groupeSecuriteRightsPoints?.changerTypePoint" [filter]="true">
        </p-dropdown>
      </div>
      <div class="col-lg-4 col-md-12 col-sm-12 mt-4">
        <span class="info-content">{{ 'privacy' | translate }}</span>
        <p-checkbox [label]="'confidentialPoint' | translate" inputId="privacy" binary="true"
          formControlName="confidentiel"></p-checkbox>
      </div>
      <div class="col-lg-4 col-md-12 col-sm-12 mt-4">
        <span class="info-content">{{ 'RGPDControl' | translate }}</span>
        <p-checkbox [label]="'passedRGPDControl' | translate" inputId="RGPDControl" binary="true"
          formControlName="checkRgpd"></p-checkbox>
      </div>
      <div class="col-lg-8 col-md-12 col-sm-12 mt-4">
        <span class="info-content">{{ 'origin' | translate }} <span
            *ngIf="mandatoryPointParameters?.origineObligatoire"> *</span></span>
        <input type="text" pInputText formControlName="origine" class="w-100" />
      </div>
      <div class="col-lg-4 col-md-12 col-sm-12 mt-4">
        <span *ngIf="displayCourrierId" class="info-content">{{ 'linkedMail' | translate }}</span>
        <div *ngIf="!duplication" class="d-flex align-items-center justify-content-between">
          <input *ngIf="displayCourrierId" type="number" pInputText formControlName="courrierId" class="w-100"
            [disabled]="true" />

          <super-button *ngIf="infosForm.value.courrierId && !filesHaveBeenSelected"
            (click)="importFileFromCourrierId()" icon="bi bi-box-arrow-in-down" class="p-button-rounded ml-2"
            styleClass="blue" [tooltip]="'importFileFromCourrier' | translate" tooltipPosition="bottom"
            [loading]="searchingMailFiles">
          </super-button>
          <super-button *ngIf="filesHaveBeenSelected" class="p-button-rounded ml-2" styleClass="blue"
            [tooltip]="'importFileFromCourrierUpdate' |translate" icon="bi bi-pencil-square"
            [text]=" selectedMailFilesToImport.length ? '(' + selectedMailFilesToImport.length + ')' : ''"
            (click)="updateImportedFilesFromMail()"></super-button>

        </div>
        <input *ngIf="displayCourrierId && duplication" type="number" pInputText formControlName="courrierId"
          class="w-100" [disabled]="true" />
      </div>
      <div class="col-lg-8 col-md-12 col-sm-12 mt-4" *ngIf="!globalConfiguration?.delibConfig?.cacherAgentTraitant">
        <span class="info-content">
          {{ 'handler' | translate }}
          <i class="bi bi-info-circle" [pTooltip]="'contactInputHelpText' | translate"></i>
        </span>
        <div class="field-radiobutton d-flex align-items-center justify-content-left">
          <div class="w-100">

            <p-autoComplete formControlName="agentTraitantIdiAdmin" [suggestions]="listeAgentsTraitantsAdminSearch"
              field="label" value="value" styleClass="w-100 userInput" appendTo="body"
              (completeMethod)="searchUser($event)" [placeholder]="'selectOneOrMoreAUser' | translate"
              [multiple]="false">
            </p-autoComplete>
            <div
              *ngIf="infosForm.get('agentTraitantIdiAdmin').invalid && infosForm.get('agentTraitantIdiAdmin').touched"
              class="text-danger">
              {{ 'Veuillez sélectionner un agent valide' }}
            </div>
          </div>
        </div>
      </div>
      <div class="col-lg-4 col-md-12 col-sm-12 mt-4">
        <span class="info-content">{{ 'decisionType' | translate }}
          <span *ngIf="mandatoryPointParameters?.typeDecisionObligatoire"> *</span>
        </span>
        <p-dropdown [virtualScroll]="true" [itemSize]="30" formControlName="typeDecisionId"
          [options]="globalElements?.decision_type_LV" styleClass="w-100"
          [placeholder]="'selectADecisionType' | translate" appendTo="body" [showClear]="true" [filter]="true">
        </p-dropdown>
      </div>
      <div class="col-lg-4 col-md-12 col-sm-12 mt-4" *ngIf="!globalConfiguration?.delibConfig?.contenuMasquerUrgence">
        <span class="info-content">{{ 'emergency' | translate }} <span
            *ngIf="mandatoryPointParameters?.urgenceObligatoire"> *</span></span>
        <p-dropdown [virtualScroll]="true" [itemSize]="30" formControlName="urgenceNiveauId"
          [options]="globalElements?.urgence_level_LV" styleClass="w-100"
          [placeholder]="'selectAnEmergency' | translate" appendTo="body" [showClear]="true" [filter]="true">
        </p-dropdown>
      </div>
    </div>
  </section>
  <section [formGroup]="infosForm" *ngIf="listOfCodesActives.length > 0">
    <div class="info-title-second">{{ 'classifying' | translate }}</div>
    <div class="row">
      <div class="col-12 mt-4">
        <div class="d-flex align-items-center justify-content-between">
          <span class="info-content">{{ 'code' | translate }} <span
              *ngIf="mandatoryPointParameters?.classementObligatoire"> *</span></span>
        </div>
        <div class="d-flex">
          <p-dropdown class="w-100 me-2" (onChange)="changeCode()" formControlName="classementId" [virtualScroll]="true"
            [itemSize]="50" [options]="listOfCodesActives | sort: 'label' : 'ASC'" styleClass="w-100"
            [placeholder]="'selectACode' | translate" appendTo="body" [showClear]="true" [filter]="true">
          </p-dropdown>
          <super-button *ngIf="rightsManagementAdmin?.menu?.codesClassement" icon="bi bi-plus-circle-fill search"
            class="mr-2" styleClass="green" (click)="createClassement()">
          </super-button>
          <super-button [disabled]="!infosForm.value.serviceId" icon="bi bi-search search" styleClass="blue"
            [tooltip]="infosForm.value.serviceId ? 'Recherche' : 'Sélectionner un service pour rechercher un classement'"
            tooltipPosition="top" (click)="searchClassements()">
          </super-button>
        </div>
      </div>
      <div class="col-12 mt-4" *ngIf="infosForm.value.classementId">
        <div class="d-flex align-items-center justify-content-between">
          <span class="info-content">{{ 'folder' | translate }}</span>
        </div>
        <div class="d-flex">
          <p-dropdown class="w-100 me-2" (onChange)="changeFolder()" formControlName="folder" [virtualScroll]="true"
            [itemSize]="50" [options]="classeurs | sort: 'label' : 'ASC'" styleClass="w-100"
            [placeholder]="'selectAFolder' | translate" appendTo="body" [showClear]="true" [filter]="true">
          </p-dropdown>
          <super-button
            *ngIf="rightsManagementAdmin?.menu?.classementDossiers || rightsManagementAdmin?.menu?.classementDossiersPartiel"
            icon="bi bi-plus-circle-fill search" styleClass="green" (click)="createFolder('folder')">
          </super-button>
        </div>
      </div>
      <div class="col-12 mt-4" *ngIf="infosForm.value.folder">
        <div class="d-flex align-items-center justify-content-between">
          <span class="info-content">{{ 'sleeve' | translate }}</span>
        </div>
        <div class="d-flex">
          <p-dropdown class="w-100 mr-2" formControlName="sleeve" [virtualScroll]="true" [itemSize]="50"
            [options]="chemises | sort: 'label' : 'ASC'" styleClass="w-100" [placeholder]="'selectASleeve' | translate"
            appendTo="body" [showClear]="true" [filter]="true">
          </p-dropdown>
          <super-button
            *ngIf="rightsManagementAdmin?.menu?.classementDossiers || rightsManagementAdmin?.menu?.classementDossiersPartiel"
            icon="bi bi-plus-circle-fill search" styleClass="green" (click)="createFolder('sleeve')">
          </super-button>
        </div>
      </div>
    </div>
  </section>
</div>

<p-dialog [(visible)]="openModalForFilesSelectionCourrier" styleClass="super-compos-modal-content" [modal]="true"
  [style]="{width: '75vw', height: 'fit-content'}" appendTo="body" [closable]="false">
  <p-header>
    <div class="d-flex align-items-center justify-content-between">
      <h5 class="modal-title super-compos-modal-title">
        Sélection des fichiers à importer
      </h5>
      <div class="d-flex">
        <super-button styleClass="blue mr-3" (click)="openModalForFilesSelectionCourrier = false"
          [text]="'btn.close'|translate"></super-button>
        <super-button styleClass="green" (click)="openModalForFilesSelectionCourrier = false; importSelectedFiles()"
          [text]="'btn.submit'|translate"></super-button>
      </div>
    </div>
  </p-header>
  <section>
    <div class="col-12">
      <super-table [initialSelection]="selectedMailFilesToImport" [forselectionDefaultOption]="false"
        #superTableFilesDuplication [forselection]="null" [items]="itemFiles|sort:'OrdreAffichage':'ASC'"
        [columns]="columnsFiles" [showForSelection]="false" id="super-files-tables-Duplication-2"
        [height]="'calc( 100vh - 400px)'" [multiselect]="true">
      </super-table>
    </div>
  </section>
</p-dialog>